import { ArrowUpRight } from "lucide-react";
import { BOOK_SECTION_ID } from "@/config/siteLinks";

export const DualAudience = () => {
  return (    <section data-testid="dual-audience-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#1C1C1A]/10 border border-[#1C1C1A]/10">
          {/* For Candidates */}
          <div data-testid="for-candidates-card" className="bg-[#F9F9F7] p-8 sm:p-12">
            <div className="relative aspect-[16/10] mb-8 overflow-hidden border border-[#1C1C1A]/10">
              <img
                src="/audience/candidates-indian.jpg"
                alt="Indian engineer ready for interviews"
                className="absolute inset-0 w-full h-full object-cover object-[center_20%]"
                loading="lazy"
              />
            </div>
            <p className="label-eyebrow text-[#143628] mb-4">For Candidates</p>
            <h3 className="font-serif-display text-3xl sm:text-4xl leading-tight tracking-tight mb-5">
              Stop applying. Start <em className="italic text-[#143628]">interviewing.</em>
            </h3>
            <p className="text-[#4A4A48] leading-relaxed mb-8">
              Built for engineers who&rsquo;d rather spend evenings building than scrolling
              job boards. We bring you opportunities. You bring the craft.
            </p>
            <ul className="space-y-3 mb-10 text-[15px]">
              {[
                "Curated roles - not 1000 generic listings",
                "Direct introductions to responsive HRs, CTOs, CEOs, etc.",
                "Resume, LinkedIn & interview prep included",
                "Get a dedicated success mentor",
              ].map((b) => (
                <li key={b} className="flex items-start gap-3 text-[#1C1C1A]">
                  <span className="mt-2 h-1 w-4 bg-[#143628] flex-shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
            <a
              href={`#${BOOK_SECTION_ID}`}
              data-testid="cta-for-candidates"
              className="inline-flex items-center gap-2 text-[#143628] border-b border-[#143628] pb-1 hover:gap-3 transition-all"
            >
              Apply as a candidate <ArrowUpRight className="h-4 w-4" />
            </a>          </div>

          {/* For Employers */}
          <div
            data-testid="for-employers-card"
            className="bg-[#143628] text-[#F9F9F7] p-8 sm:p-12 relative overflow-hidden"
          >
            <div className="relative aspect-[16/10] mb-8 overflow-hidden border border-white/10">
              <img
                src="/audience/employers-indian.jpg"
                alt="Indian startup team reviewing hiring strategy"
                className="absolute inset-0 w-full h-full object-cover opacity-90"
                loading="lazy"
              />
            </div>
            <p className="label-eyebrow text-[#D4B886] mb-4">For Employers</p>
            <h3 className="font-serif-display text-3xl sm:text-4xl leading-tight tracking-tight mb-5">
              Pre-vetted talent.{" "}
              <em className="italic text-[#D4B886]">Zero noise.</em>
            </h3>
            <p className="text-[#F9F9F7]/80 leading-relaxed mb-8">
              We send you only candidates we&rsquo;d hire ourselves. India&rsquo;s top 1% in AI,
              Full-Stack, and Data Engineers - pre-screened and ready to interview.
            </p>
            <ul className="space-y-3 mb-10 text-[15px]">
              {[
                "Get quality profiles per role",
                "Skills, projects & culture-fit verified",
                "No platform fees",
                "Increase hiring efficiency by 53%",
              ].map((b) => (
                <li key={b} className="flex items-start gap-3 text-[#F9F9F7]">
                  <span className="mt-2 h-1 w-4 bg-[#D4B886] flex-shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
            <a
              href={`#${BOOK_SECTION_ID}`}
              data-testid="cta-for-employers"
              className="inline-flex items-center gap-2 text-[#D4B886] border-b border-[#D4B886] pb-1 hover:gap-3 transition-all"
            >
              Hire through JobNex <ArrowUpRight className="h-4 w-4" />
            </a>          </div>
        </div>
      </div>
    </section>
  );
};

export default DualAudience;
